
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M47.1 13.9c-.6-.3-1.1-.5-1.6-.6l.6-1.1c.7-1.2.8-2.6.4-4-.4-1.2-1.3-2.3-2.5-3s-2.6-.9-4-.6c-1.4.4-2.5 1.2-3.2 2.4L22.6 32c-1.2 2-1.3 9.4-1.3 10.8 0 .5.2.9.6 1.1.2.1.4.2.6.2s.4-.1.6-.2c1.2-.7 7.5-4.6 8.6-6.6l11.4-20c.4-.7.8-1.1 1.3-1.3.3-.1.7-.2 1.3.2.4.2 1.4.8.3 2.7l-5.3 9.3c-.3.6-.1 1.4.5 1.7.6.3 1.4.1 1.7-.5l5.3-9.3c1.6-2.5 1.1-4.9-1.1-6.2zM29.7 36c-.4.8-3.1 2.7-5.8 4.5.1-3.3.4-6.5.9-7.3L39 8.3c.3-.6.9-1 1.6-1.2.2-.1.4-.1.6-.1.5 0 1 .1 1.5.4.7.4 1.2 1 1.4 1.7.2.7.1 1.4-.2 2l-2.8 5L29.7 36zM17.9 42.1c-.7.1-1.4-.2-1.7-.8-.4-.6-.3-1.5.3-2.1.4-.4.5-1.1.1-1.6s-1.1-.6-1.6-.3c-1.6.9-3.1.7-3.8.1-.5-.4-.7-1.2-.7-2 0-.9.3-1.7.8-2.4.4-.3.8-.7 1.1-1.1.4-.5.3-1.2-.1-1.7-.5-.4-1.2-.5-1.7-.1-.4.3-.8.7-1.1 1.1-1 .8-2.2 1.1-3.2.8-2.1-.6-2.5-3.7-2.6-4.1-.2-2.2.8-4.7 2.7-6.6 1.4-1.4 3-2.1 4.4-1.9 1.7.2 3 1.7 3.6 2.6.4.6 1.2.7 1.7.3.6-.4.7-1.2.3-1.7-1-1.5-2.8-3.3-5.3-3.7-2.2-.3-4.5.6-6.5 2.6-2.4 2.4-3.8 5.7-3.5 8.6.1.9.7 5.2 4.4 6.2.8.2 1.6.2 2.4.1 0 .2-.1.5-.1.8 0 1.6.5 3 1.5 3.9s2.5 1.3 4 1.1c0 .8.2 1.6.6 2.2.8 1.2 2.1 2 3.6 2 .2 0 .5 0 .7-.1.7-.1 1.1-.8 1-1.4.1-.4-.6-.9-1.3-.8z"}})])
          )
        }
      }
    